module.exports = __webpack_public_path__ + "img/lucio_ciccarone.459c631a.png";